import { useSearchParams } from 'react-router-dom';
import InfoContentTabsList from './components/InfoContentTabsList';

function InfoContent() {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'terms';
  const items = InfoContentTabsList();

  return items.find((item) => item.key === activeTab)?.children;
}

export default InfoContent;
